import { IShiftTimingModel } from "@core/models/iShiftTimingModel";

 
export class ShiftTimingActionStore {
  static readonly type = '[shiftTimings] shiftTimings';

  constructor(public payload: IShiftTimingModel) {}
}